import { apiRequest } from "../api/http";

// Route permissions per category/language (read by the apps, changed by an
// admin with the "app_menu" section); both reject on failure.

export function getPermissions() {
  return apiRequest("get", "/api/permission/get-permission", {
    rethrow: true,
  });
}

export function setPermissions(permissionId, permissions) {
  return apiRequest("put", `/api/permission/set-permission/${permissionId}`, {
    data: permissions,
    rethrow: true,
  });
}
